// extracted by mini-css-extract-plugin
export default {"letters":"LetterList_letters__63bwY","selected":"LetterList_selected__uwG0L"};